<template>
    <v-sheet class="py-7" width="100%">
        <v-row class="pa-0" no-gutters>
            <v-col class="d-flex align-center" cols="12">
                <v-icon color="blue102">mdi-chevron-down</v-icon>
                <span class="ml-2 font-weight-bold fontOneToOne blue102--text">{{ sndConnInf?.eSigNm }}</span>
                <v-spacer></v-spacer>
                <span class="grey006--text fontDotNine mr-1"></span>
            </v-col>
        </v-row>
        <v-divider class="mx-2 mt-4"></v-divider>
        <v-row v-for="(list, i) in tblList" :key="i" class="mx-2 tableBB" no-gutters>
            <v-col class="nmlBfClr-grey001 txtAlgnMid py-1" cols="4">
                <span class="fontDotEight font-weight-bold">{{ list.label }}</span>
            </v-col>
            <v-col class="d-flex align-center pl-4 tableBL" cols="8">
                <span class="fontDotEight">{{ list.val }}</span>
            </v-col>
        </v-row>
        <v-row class="mx-2" no-gutters>
            <v-col class="nmlBfClr-grey001 txtAlgnMid py-1" cols="4">
                <span class="fontDotEight font-weight-bold">확인사항</span>
            </v-col>
            <v-col class="d-flex align-center pl-4 py-1 tableBL" cols="8">
                <v-btn
                    :class="['px-3', falRskList.length > 0 ? 'blue001 white--text' : '']"
                    @click="isFalRsk = true" :disabled="falRskList.length == 0"
                    outlined rounded small>
                    <v-icon class="" size="18">mdi-checkbox-multiple-marked-circle-outline</v-icon>
                    <span class="fontDotNine ml-2" style="padding-bottom: 3px;">
                        확인사항&nbsp;&#40;&nbsp;{{ falRskList.filter( v => v.cnfmYn == '1' ).length }}/{{ falRskList.length }}&nbsp;&#41;
                    </span>
                </v-btn>
            </v-col>
        </v-row>
        <v-divider class="mx-2"></v-divider>
        <v-divider class="mx-2 mt-4"></v-divider>
        <v-row class="justify-center pt-4" no-gutters>
            <v-btn
                v-if="sgnInf.prsnInfYn == '1'"
                class="mb-2" color="grey006"
                :disabled="sgnInf.bnMmbrPk == 0"
                @click="prtAgrCall"
                outlined rounded>
                <v-icon class="" size="18">mdi-printer-outline</v-icon>
                <span class="fontDotNine ml-2" style="padding-bottom: 2px;">개인정보 수집 및 동의서 상세내용 확인</span>
            </v-btn>
            <v-btn
                v-if="sgnInf.eldRghtYn == '1'"
                class="mb-2" color="grey006"
                :disabled="sgnInf.bnMmbrPk == 0"
                @click="prtEldCall"
                outlined rounded>
                <v-icon class="" size="18">mdi-printer-outline</v-icon>
                <span class="fontDotNine ml-2" style="padding-bottom: 2px;">노인인권 보호지침 상세내용 확인</span>
            </v-btn>
            <v-btn
                v-if="sgnInf.bnfcrSftyYn == '1'"
                class="mb-2" color="grey006"
                :disabled="sgnInf.bnMmbrPk == 0"
                @click="prtSftCall"
                outlined rounded>
                <v-icon class="" size="18">mdi-printer-outline</v-icon>
                <span class="fontDotNine ml-2" style="padding-bottom: 2px;">수급자 안전관리 통지서 상세내용 확인</span>
            </v-btn>
            <v-btn
                v-if="sgnInf.empRghtYn == '1'"
                class="mb-2" color="grey006"
                @click="prtEmpCall"
                outlined rounded>
                <v-icon class="" size="18">mdi-printer-outline</v-icon>
                <span class="fontDotNine ml-2" style="padding-bottom: 2px;">직원 인권 보호 상세내용 확인</span>
            </v-btn>
            <v-btn
                v-if="sgnInf.lfssDcsnYn == '1'"
                class="mb-2" color="grey006"
                @click="prtOldHosCall"
                outlined rounded>
                <v-icon class="" size="18">mdi-printer-outline</v-icon>
                <span class="fontDotNine ml-2" style="padding-bottom: 2px;">연명의료 결정제도 상세내용 확인</span>
            </v-btn>
        </v-row>
        <v-divider class="mt-2 mb-4 mx-2"></v-divider>
        <v-row v-if="sgnInf.isFile == 'N'" class="" no-gutters>
            <v-col class="d-flex justify-center" cols="12">
                <vue-esign
                    class="rounded" style="border: 3px solid #4bc5e8;"
                    ref="esign" format="image/png" :width="signWidth" :height="signHeight"
                    :isCrop="isCrop" :lineWidth="lineWidth" :lineColor="lineColor" :bgColor.sync="bgColor">
                </vue-esign>
            </v-col>
        </v-row>
        <v-row v-else-if="sgnInf.isFile == 'Y'" class="" no-gutters>
            <v-col class="d-flex justify-center" cols="12">
                <span class="d-iline-block" style="width: 280px; height: 210px;">
                    <v-img
                        class="rounded" style="border: 3px solid #4bc5e8;"
                        :src="sgnInf.photoImg"
                        width="280" height="210" aspect-ratio="4/3">
                    </v-img>
                </span>
            </v-col>
        </v-row>
        <v-row v-if="sgnInf.isFile == 'N'" class="justify-end pt-3 px-6" no-gutters>
            <v-btn
                style="font-size: 16px;" height="26" color="grey006"
                @click="handleReset" outlined rounded>
                <v-icon class="mr-1" size="18">mdi-eraser</v-icon>
                <span>서명&nbsp;지우기</span>
            </v-btn>
        </v-row>
        <v-row v-else-if="sgnInf.isFile == 'Y'" class="justify-end pt-3 px-6" no-gutters>
            <v-btn
                style="font-size: 16px;" height="26" color="grey006"
                @click="sgnInf.isFile = 'N', sgnInf.photoImg = ''" outlined rounded>
                <v-icon class="mr-1" size="18">mdi-eraser</v-icon>
                <span>서명&nbsp;다시하기</span>
            </v-btn>
        </v-row>
        <v-divider class="mx-2 mt-4"></v-divider>
        <v-row class="greyE01 mx-2" no-gutters>
            <v-col class="txtAlgnMid py-1 px-3" cols="12">
                <span class="font-weight-medium fontDotEight">※ 본인의 이름을 정자로 입력하시기 바랍니다.</span>
            </v-col>
        </v-row>
        <v-divider class="mx-2"></v-divider>
        <v-divider class="mx-2 mt-1"></v-divider>
        <v-row class="greyE01 mx-2" no-gutters>
            <v-col class="d-flex justify-center align-center pl-2" cols="2">
                <v-checkbox
                    v-model="sgnInf.cfmYn" :ripple="false"
                    class="cmmSqrBox mt-0" style="" true-value="1" false-value="2"
                    hide-details>
                </v-checkbox>
            </v-col>
            <v-col class="d-flex align-center py-1 pr-3" style="line-height: 14px;" cols="10">
                <div>
                    <span class="fontDotSeven">위의&nbsp;{{ sndConnInf?.eSigNm }}에 대해 상세히 설명 들었음을 확인합니다. </span>
                    <span class="fontDotSeven">본인이 맞으며 전자서명 등록과 사용에 동의합니다.</span>
                </div>
            </v-col>
        </v-row>
        <v-divider class="mx-2 mb-4"></v-divider>
        <v-row class="justify-center" no-gutters>
            <span v-if="sgnInf.isFile == 'N'">
                <v-btn
                    :class="['pl-9 pr-10', saveBtn || sgnInf.cfmYn == '2' ? '' : 'blue001 white--text']"
                    @click="handleGenerate" :disabled="saveBtn || sgnInf.cfmYn == '2'"
                    outlined rounded>
                    <v-icon class="" size="18">mdi-content-save-outline</v-icon>
                    <span class="fontDotNine ml-2" style="padding-bottom: 2px;">저장</span>
                </v-btn>
            </span>
        </v-row>

        <v-dialog v-model="isFalRsk" eager>
            <v-sheet
                class="ma-0 pa-4" rounded="lg">
                <v-row class="pa-0" no-gutters>
                    <v-col class="d-flex align-center" cols="10">
                        <span class="font-weight-medium fontOneToTwo">낙상위험 방지 확인사항</span>
                    </v-col>
                    <v-col class="d-flex" cols="2">
                        <v-spacer></v-spacer>
                        <v-btn
                            @click="isFalRsk = false"
                            style="margin-top: 2px;" icon>
                            <v-icon class="grey006--text" size="30">mdi-close</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
                <v-divider class="mt-3"></v-divider>
                <v-row class="pa-0" no-gutters>
                    <v-col class="py-1 greyE02" style="text-align: center;" cols="12">
                        <span class="fontOne font-weight-medium">낙상위험 방지 관련 확인사항</span>
                    </v-col>
                </v-row>
                <v-divider class=""></v-divider>
                <v-row class="pa-0" no-gutters>
                    <v-col class="" cols="12">
                        <div
                            :class="['pa-1', cfm.cnfmYn == '1' ? 'tableBB' : '']" style="line-height: 1.3;"
                            v-for="(cfm, i) in falRskList" :key="i"
                            >
                            <span v-if="cfm.cnfmYn == '1'" class="fontDotNine">{{ cfm.cnfmCntntDtl }}</span>
                        </div>
                    </v-col>
                </v-row>
                <v-row class="pa-0" no-gutters>
                    <v-col class="d-flex justify-center" cols="12">
                        <v-checkbox
                            v-model="agrCnfm" label="위 항목을 확인했습니다."
                            class="mt-3" style="" true-value="1" false-value="2"
                            on-icon="mdi-check-circle-outline" off-icon="mdi-minus-circle-outline"
                            hide-details>
                        </v-checkbox>
                    </v-col>
                </v-row>
                <v-divider class="white my-1"></v-divider>
                <!-- <v-row class="pa-0 mt-3 mb-2" no-gutters>
                    <v-col class="d-flex justify-center" cols="12">
                        <v-btn
                            class="ml-3 white--text" height="26" color="blue001" rounded :disabled="agrCnfm == '2'" @click="handleGenerate"
                            style="font-size: 16px;">
                            <v-icon class="mr-1" size="18">mdi-content-save-outline</v-icon>
                            저장
                        </v-btn>
                    </v-col>
                </v-row> -->
            </v-sheet>
        </v-dialog>
    </v-sheet>
</template>

<script>
import { http } from '@/assets/js/baseAxios';

export default {
    name: 'OutPrivacyAgrBtch',

    components: {
        
    },

    props: {
        aplyYyMm: { type: String, default: '' }
    },

    created: function(){

    },

    mounted: function(){
        this.$nextTick(function () {
            // let obj = {}
            // obj.bnMmbrPk = 16
            // obj.fcltyNum = 14111000790
            // obj.inqYYMM = 202307

            // let encrypted = this.$crypto.AES.encrypt(JSON.stringify(obj), this.$store.getters.getCrypKey)
            // console.log(encrypted.toString())
            // let bs64 = this.$crypto.enc.Base64.stringify(this.$crypto.enc.Utf8.parse(encrypted.toString()))
            // console.log(bs64)

            this.rflQuery()
        })
    },

    computed: {
       
    },

    watch:{

    },
        
    methods: {
        // 전자서명 조회 Params
        getSgnMgmtInf: function (obj){
            this.saveBtn = true
            this.falRskList.splice(0)
            this.clearInf()

            http.post('fmly/selAgrOfrBtchInfo', obj)
                .then((response) => ( this.sgnMgmtRst(response.data) ))
                .catch((error) => console.log('axios error /fmly/selAgrOfrBtchInfo : ' + error))
        },
        sgnMgmtRst: function (res){
            this.sgnInf.isFile = res.result.isFile
            this.sgnInf.prsnInfAgrPk = res.result.prsnInfAgrPk
            this.sgnInf.bnfcrSftyPk = res.result.bnfcrSftyPk

            if(res.result.bnMmbrPk == '')
                this.sgnInf.bnMmbrPk = 0
            else
                this.sgnInf.bnMmbrPk = Number(res.result.bnMmbrPk)

            if(res.result.inqYYYY != '')
                this.sgnInf.inqYYYY = res.result.inqYYYY
            if(res.result.list.length > 0)
                this.tblList = res.result.list
            if(res.result.photoImg != null)
                this.sgnInf.photoImg = 'data:image/png;base64,' + res.result.photoImg

            if(res.result.prsnInfYn == '1')
                this.sgnInf.prsnInfYn = '1'
            if(res.result.eldRghtYn == '1')
                this.sgnInf.eldRghtYn = '1'
            if(res.result.bnfcrSftyYn == '1')
                this.sgnInf.bnfcrSftyYn = '1'
            if(res.result.empRghtYn == '1')
                this.sgnInf.empRghtYn = '1'
            if(res.result.lfssDcsnYn == '1')
                this.sgnInf.lfssDcsnYn = '1'

            if(Array.isArray(res.result.falRskList))
                res.result.falRskList.forEach(itm => {
                    if(itm.cnfmYn == '1')
                        this.falRskList.push(itm)
                });
                //this.falRskList = res.result.falRskList

            this.saveBtn = false
        },

        // PDF 조회
        getRptInf: function (){
            let obj = Object.assign({}, this.prtThrowObj)
            obj.fcltyNum = this.$parent.$parent.sltFcltyNum
            obj.bnMmbrPk = this.sgnInf.bnMmbrPk
            // obj.prtClcd = '1'
            // obj.prtCd = this.sndConnInf.prtCd
            // obj.inqYYYY = this.sgnInf.inqYYYY
            // obj.list = []
            // obj.list.push( { bzClcd: [this.sndConnInf.bzClcd], bzPk: [this.sndConnInf.bzClcdPk] } )
   
            http.post('fmly/reportInfo', obj)
                .then((response) => ( this.rptInfRst(response.data) ))
                .catch((error) => console.log('axios error /fmly/reportInfo : ' + error))
        },
        rptInfRst: function (res){
            if(res.statusCode == '200'){
                if(res.prtClcd == '1')
                    this.$store.commit('setCmmPdfDstnt', 'imgPrview')
                else
                    this.$store.commit('setCmmPdfDstnt', 'imgView')
                this.$store.commit('setCmmPdfPth', res.filePth)
                this.$store.commit('setCmmPdfNm', res.fileNm)
                this.$store.commit('setCmmPdfOrgNm', res.orgFileNm)
                this.$store.commit('setCmmPdfTtl', this.sndConnInf.ttl)
                this.$store.commit('setCmmPrtMdl', true)
            }
            else{
                this.$store.commit('setCmmAlertMdl', true)
                this.$store.commit('setCmmAlertCntn', { clr: 'error', cntn: res.message })
            }
        },

        // 전자서명 저장
        setDirtSgn: function (obj){
            this.saveBtn = true
  
            http.post('fmly/setAgrOfrBtch', obj)
                .then((response) => ( this.asyncRst(response.data) ))
                .catch((error) => console.log('axios error /fmly/setAgrOfrBtch : ' + error))
        },

        asyncRst: function (res){
            let sgnObj = Object.assign({}, this.sndConnInf)
            sgnObj.fcltyNum = this.$parent.$parent.sltFcltyNum
            this.getSgnMgmtInf(sgnObj)

            let obj = {}
            if(res.statusCode == '200')
                obj.clr = 'info'
            else
                obj.clr = 'error'

            obj.cntn = res.message

            this.$store.commit('setCmmAlertMdl', true)
            this.$store.commit('setCmmAlertCntn', obj)
            this.saveBtn = false
            this.clearInf()
        },

        preIndSgn: function () {
            this.saveBtn = true

            let oObj = Object.assign({}, this.sndConnInf)
            oObj.fcltyNum = this.$parent.$parent.sltFcltyNum
            oObj.bnMmbrPk = oObj.mmbrPk
            oObj.prsnInfYn = this.sgnInf.prsnInfYn
            oObj.eldRghtYn = this.sgnInf.eldRghtYn
            oObj.bnfcrSftyYn = this.sgnInf.bnfcrSftyYn
            oObj.empRghtYn = this.sgnInf.empRghtYn
            oObj.lfssDcsnYn = this.sgnInf.lfssDcsnYn
            oObj.cnfmYn = this.sgnInf.cfmYn
            oObj.falRskCnfmYn = this.agrCnfm
            oObj.sign = this.sign

            this.setDirtSgn(oObj)
        },

        // canvas Clear
        handleReset: function () {
            this.$refs.esign.reset()
        },

        // convert canvas to base64
        handleGenerate: function () {
            this.$refs.esign.generate().then(res => {
                this.sign = res
                this.preIndSgn()
            }).catch(err => {
                console.log(err)
            })
        },

        // get param 복호화
        rflQuery: function () {
            if(typeof this.$route.query.dstnt != 'undefined'){
                if(this.$route.query.dstnt != ''){
                    let bs64 = this.$crypto.enc.Utf8.stringify(this.$crypto.enc.Base64.parse(this.$route.query.dstnt))
                    let bytes = this.$crypto.AES.decrypt(bs64, this.$store.getters.getCrypKey)

                    this.onPayExpStt(JSON.parse(bytes.toString(this.$crypto.enc.Utf8)))
                }
            }
            else{
                this.$store.commit('setCmmAlertMdl', true)
                this.$store.commit('setCmmAlertCntn', { clr: 'error', cntn: '잘못된 접근 입니다.' })
            }
        },
        onPayExpStt: function (obj) {
            let tmp = Object.assign({}, obj)
            
            this.$parent.$parent.sltFcltyNum = tmp.fcltyNum
            this.sndConnInf.ttl = tmp.title
            this.sndConnInf.agrOfrBtchSndPk = tmp.bzPk
            this.sndConnInf.eSigClcd = tmp.clcd
            this.sndConnInf.mmbrPk = tmp.mmbrPk
            this.sndConnInf.name = tmp.name
            this.sndConnInf.prtCd = tmp.prtCd
            this.sndConnInf.eSigNm = tmp.title
            this.sndConnInf.bzClcd = tmp.bzClcd
            this.$parent.$parent.appBarTtl = tmp.title

            let sgnObj = Object.assign({}, this.sndConnInf)
            sgnObj.fcltyNum = this.$parent.$parent.sltFcltyNum

            this.getSgnMgmtInf(sgnObj)
        },

        // 개인정보 이용동의 출력
        prtAgrCall: function () {
            this.prtThrowObj.list[0].bzPk.splice(0)
            this.prtThrowObj.list[0].bzClcd.splice(0)
            this.prtThrowObj.prtCd = '25'
            this.prtThrowObj.prtClcd = '1'

            if(this.sgnInf.prsnInfAgrPk == 0){
                this.prtThrowObj.list[0].bzClcd.push(41)
                this.prtThrowObj.list[0].bzPk.push(this.sndConnInf.agrOfrBtchSndPk)
            }
            else{
                this.prtThrowObj.list[0].bzClcd.push(32)
                this.prtThrowObj.list[0].bzPk.push(this.sgnInf.prsnInfAgrPk)
            }

            this.getRptInf()
        },

        // 노인인권 보호지침 출력
        prtEldCall: function () {
            this.prtThrowObj.list[0].bzPk.splice(0)
            this.prtThrowObj.list[0].bzClcd.splice(0)
            this.prtThrowObj.prtCd = '201'
            this.prtThrowObj.prtClcd = '2'

            this.getRptInf()
        },

        // 안전관리 통지서 출력
        prtSftCall: function () {
            this.prtThrowObj.list[0].bzPk.splice(0)
            this.prtThrowObj.list[0].bzClcd.splice(0)

            if(this.sgnInf.bnfcrSftyPk == 0){
                this.prtThrowObj.list[0].bzClcd.push(41)
                this.prtThrowObj.list[0].bzPk.push(this.sndConnInf.agrOfrBtchSndPk)
            }
            else{
                this.prtThrowObj.list[0].bzClcd.push(32)
                this.prtThrowObj.list[0].bzPk.push(this.sgnInf.bnfcrSftyPk)
            }

            this.prtThrowObj.prtCd = '26'
            this.prtThrowObj.prtClcd = '1'

            this.getRptInf()
        },

        // 직원인권 출력
        prtEmpCall: function () {
            this.prtThrowObj.list[0].bzPk.splice(0)
            this.prtThrowObj.list[0].bzClcd.splice(0)
            this.prtThrowObj.prtCd = '207'
            this.prtThrowObj.prtClcd = '2'

            this.getRptInf()
        },

        // 연명의료 출력
        prtOldHosCall: function () {
            this.prtThrowObj.list[0].bzPk.splice(0)
            this.prtThrowObj.list[0].bzClcd.splice(0)
            this.prtThrowObj.prtCd = '208'
            this.prtThrowObj.prtClcd = '2'

            this.getRptInf()
        },

        clearInf: function () {
            this.sgnInf.bnMmbrPk = 0
            this.sgnInf.bnfcrNm = ''
            this.sgnInf.celphn = ''
            this.sgnInf.fmName = ''
            this.sgnInf.rsdntBirth = ''
            this.sgnInf.isFile = ''
            this.sgnInf.photoImg = ''
            this.sgnInf.cfmYn = '2'

            this.sgnInf.prsnInfYn = '2'
            this.sgnInf.eldRghtYn = '2'
            this.sgnInf.bnfcrSftyYn = '2'
            this.sgnInf.empRghtYn = '2'
            this.sgnInf.lfssDcsnYn = '2'

            this.sgnInf.prsnInfAgrPk = 0
            this.sgnInf.bnfcrSftyPk = 0
        },

        goPage:function(url){
            window.open(url, '_blank')
        }
    },

    data: () => ({
        sign: '',
        lineWidth: 6,               //브러시 굵기 (2, 4, 6, 8, 10)
        lineColor: '#000000',       //브러시 색상
        bgColor: '',                //캔버스 색상
        resultImg: '',              //생성된 이미지
        isCrop: false,              //자르기
        signWidth: 280,
        signHeight: 210,
        saveBtn: true,
        agrCnfm: '2',
        isFalRsk: false,
        falRskList: [],
        tblList: [],
        sndConnInf: { bzClcdPk: 0, agrOfrBtchSndPk: 0, eSigClcd: 0, eSigNm: '', mmbrPk: 0, name: '', prtCd: '', bzClcd: '', ttl:'' },
        sgnInf: {
            bnMmbrPk: 0, bnfcrNm: '', celphn: '', fmName: '', rsdntBirth: '', inqYYYY: '', isFile: '', photoImg: '', cfmYn: '2',
            prsnInfYn: '2', eldRghtYn: '2', bnfcrSftyYn: '2', empRghtYn: '2', lfssDcsnYn: '2', prsnInfAgrPk: 0, bnfcrSftyPk: 0
        },
        prtThrowObj: {                                                  // 출력물 관리 정보
            prtClcd: '1', inqClcd: 2, prtCd: '4', inqYYYY: '', list: [ { bzClcd: [], bzPk: [] } ],
        },
    }),
};
</script>